/* The Angarkha — global.js v2
   Dependency-free. Cursor, reveal, nav, cart drawer (AJAX), quick add,
   PDP gallery + option buttons + add-to-bag. */

(function () {
  'use strict';

  var moneyFormat = document.body.getAttribute('data-money-format') || '₹{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    // Indian-style grouping for whole rupees
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{2})+(?!\d)\d{1})/g, ',').replace(/^(\d),/, '$1,');
    // Fall back to simple grouping if the regex mangled it
    if (!/^\d{1,3}(,\d{2,3})*$/.test(parts[0])) parts[0] = (+amount.split('.')[0]).toLocaleString('en-IN');
    amount = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount[^}]*\}\}/, amount)
      .replace(/&#8377;|&#x20B9;/g, '₹');
  }

  /* ---- Custom cursor (desktop only) ---- */
  var cur = document.getElementById('cur');
  var curR = document.getElementById('curR');
  if (cur && curR && window.matchMedia('(pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cur.style.transform = 'translate(' + (mx - 5.5) + 'px,' + (my - 5.5) + 'px)';
    });
    (function anim() {
      rx += (mx - rx - 17) * 0.11;
      ry += (my - ry - 17) * 0.11;
      curR.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      requestAnimationFrame(anim);
    })();
  }

  /* ---- Nav scroll state ---- */
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vis'); ro.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function (el) { ro.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('vis'); });
  }

  /* ---- Cart drawer ---- */
  var drawer = document.getElementById('cartDrawer');

  function openDrawer() { if (drawer) { refreshDrawer(); drawer.classList.add('open'); } }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('.cdbody');
    var sub = drawer.querySelector('[data-drawer-subtotal]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    updateCartCount(cart.item_count);
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (!body) return;

    if (cart.items.length === 0) {
      body.innerHTML = '<div class="cdempty">' + (drawer.getAttribute('data-empty-text') || 'Nothing here yet. Go find your tale.') + '</div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var art = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="" loading="lazy">'
        : '<span>' + item.product_title.charAt(0) + '</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return '<div class="cdi" data-line-key="' + item.key + '">' +
        '<div class="cdi-art">' + art + '</div>' +
        '<div>' +
          '<div class="cdi-nm">' + item.product_title + '</div>' +
          (variant ? '<div class="cdi-v">' + variant + '</div>' : '') +
          '<div class="cdi-pr">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cdi-qty">' +
            '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
            '<button type="button" class="cdi-rm" data-qty-remove aria-label="Remove">✕</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }

  function refreshDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-drawer]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      var current = parseInt(line.querySelector('.cdi-qty span').textContent, 10);
      changeLine(line.getAttribute('data-line-key'), Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty-change'), 10)));
      return;
    }
    var rmBtn = e.target.closest('[data-qty-remove]');
    if (rmBtn) {
      changeLine(rmBtn.closest('[data-line-key]').getAttribute('data-line-key'), 0);
      return;
    }

    /* Quick add (first available variant) */
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var vid = qa.getAttribute('data-quick-add');
      qa.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        qa.textContent = 'Added ✓';
        setTimeout(function () { qa.textContent = qa.getAttribute('data-label') || 'Quick Add'; openDrawer(); }, 500);
      }).catch(function () {
        qa.textContent = 'Unavailable';
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---- PDP: gallery ---- */
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('.slide');
    var thumbs = gallery.querySelectorAll('.pdp-thumb');
    var current = 0;
    function show(i) {
      current = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('on', current === j); });
      thumbs.forEach(function (t) {
        var idx = parseInt(t.getAttribute('data-slide-index'), 10);
        t.classList.toggle('on', current === idx);
      });
    }
    thumbs.forEach(function (thumb) {
      var idx = parseInt(thumb.getAttribute('data-slide-index'), 10);
      thumb.addEventListener('click', function () { show(idx); });
    });
    gallery.querySelectorAll('[data-slide-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(current + parseInt(btn.getAttribute('data-slide-nav'), 10));
      });
    });
    gallery.showSlide = show;

    /* Lightbox: click main image to enlarge */
    var lightbox = gallery.querySelector('[data-lightbox]');
    if (lightbox) {
      var lbImg = lightbox.querySelector('[data-lb-img]');
      function openLightbox() {
        var img = slides[current] ? slides[current].querySelector('img') : null;
        if (!img) return;
        lbImg.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
        lbImg.alt = img.alt || '';
        lbImg.classList.remove('zoomed');
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function closeLightbox() {
        lightbox.hidden = true;
        lbImg.classList.remove('zoomed');
        document.body.style.overflow = '';
      }
      gallery.querySelectorAll('.pdp-main-img .slide img').forEach(function (img) {
        img.addEventListener('click', openLightbox);
      });
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        lbImg.classList.toggle('zoomed');
      });
      lightbox.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      lightbox.querySelectorAll('[data-lb-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(current + parseInt(btn.getAttribute('data-lb-nav'), 10));
          openLightbox();
        });
      });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') { show(current - 1); openLightbox(); }
        if (e.key === 'ArrowRight') { show(current + 1); openLightbox(); }
      });
    }
  });

  /* ---- Quote break: carousel ---- */
  document.querySelectorAll('[data-qbreak]').forEach(function (qb) {
    var slides = qb.querySelectorAll('.qbreak-slide');
    if (slides.length < 2) return;
    var dots = qb.querySelectorAll('.qbreak-dot');
    var current = 0;
    var autoSeconds = parseFloat(qb.getAttribute('data-qbreak-auto'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function show(i) {
      current = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('on', current === j); });
      dots.forEach(function (d, j) { d.classList.toggle('on', current === j); });
    }
    function restart() {
      clearInterval(timer);
      if (!autoSeconds || reduceMotion) return;
      timer = setInterval(function () { show(current + 1); }, autoSeconds * 1000);
    }
    qb.querySelectorAll('[data-qbreak-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(current + parseInt(btn.getAttribute('data-qbreak-nav'), 10));
        restart();
      });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); restart(); });
    });
    restart();
  });

  /* ---- PDP: size chart modal ---- */
  document.querySelectorAll('[data-sizechart-modal]').forEach(function (modal) {
    var wrapper = modal.closest('[data-product-form]') || document;
    var openBtns = wrapper.querySelectorAll('[data-sizechart-open]');
    var closeBtn = modal.querySelector('[data-sizechart-close]');
    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
    });
  });

  /* ---- PDP: options, qty, add to bag ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = wrapper.querySelector('form[data-atc-form]');
    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var atcBtn = wrapper.querySelector('[data-atc-button]');
    var atcLabel = atcBtn ? atcBtn.getAttribute('data-label') : 'Add to Bag';
    var soldLabel = atcBtn ? atcBtn.getAttribute('data-sold-label') : 'Sold Out';
    var buynowWrap = wrapper.querySelector('[data-buynow-wrap]');
    var buynowId = wrapper.querySelector('[data-buynow-id]');
    var buynowQty = wrapper.querySelector('[data-buynow-qty]');

    function selectedOptions() {
      return Array.prototype.map.call(wrapper.querySelectorAll('[data-option-group]'), function (group) {
        var on = group.querySelector('.on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function currentVariant() {
      var chosen = selectedOptions();
      return product.variants.find(function (v) {
        return chosen.every(function (val, i) { return v['option' + (i + 1)] === val; });
      });
    }

    function update() {
      var variant = currentVariant();
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (buynowId) buynowId.value = variant.id;
      if (buynowWrap) buynowWrap.hidden = !variant.available;
      var priceHtml = formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        priceHtml = '<span class="price-compare">' + formatMoney(variant.compare_at_price) + '</span><span class="price-sale">' + formatMoney(variant.price) + '</span>';
      }
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available
          ? atcLabel + ' — ' + formatMoney(variant.price)
          : soldLabel;
      }
      var gal = wrapper.querySelector('[data-pdp-gallery]');
      if (gal && gal.showSlide && variant.featured_image && variant.featured_image.position) {
        gal.showSlide(variant.featured_image.position - 1);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Option buttons */
    wrapper.querySelectorAll('[data-option-group]').forEach(function (group) {
      var valueLabel = group.querySelector('[data-selected-value]');
      group.querySelectorAll('button[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button[data-value]').forEach(function (b) { b.classList.remove('on'); });
          btn.classList.add('on');
          if (valueLabel) valueLabel.textContent = btn.getAttribute('data-value');
          update();
        });
      });
    });

    /* Qty stepper */
    var qtyInput = wrapper.querySelector('.qty-input');
    wrapper.querySelectorAll('[data-qty-adjust]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) + parseInt(btn.getAttribute('data-qty-adjust'), 10);
        if (v >= 1 && v <= 99) {
          qtyInput.value = v;
          if (buynowQty) buynowQty.value = v;
        }
      });
    });

    /* AJAX add to bag */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variant = currentVariant();
        if (!variant || !variant.available) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: parseInt(qtyInput ? qtyInput.value : '1', 10) || 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          if (atcBtn) {
            atcBtn.textContent = 'Added ✓';
            atcBtn.style.background = 'var(--teal)';
            atcBtn.style.color = 'var(--black)';
            setTimeout(function () {
              atcBtn.style.background = '';
              atcBtn.style.color = '';
              update();
              openDrawer();
            }, 800);
          } else {
            openDrawer();
          }
        }).catch(function () {
          // Fall back to a normal form post
          form.submit();
        });
      });
    }

    update();
  });

  /* ---- Sir Angar: signature look (annotation → detail shot) ---- */
  document.querySelectorAll('[data-angar-look]').forEach(function (look) {
    var slides = look.querySelectorAll('[data-look-slide]');
    var notes = look.querySelectorAll('[data-look-note]');
    var reset = look.querySelector('[data-look-reset]');
    if (!slides.length || !notes.length) return;

    function show(key) {
      var matched = false;
      slides.forEach(function (s) {
        var on = s.getAttribute('data-look-slide') === key;
        s.classList.toggle('on', on);
        if (on) matched = true;
      });
      // If the requested detail shot is missing, fall back to the full figure
      if (!matched) {
        slides.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-look-slide') === 'figure'); });
        key = 'figure';
      }
      notes.forEach(function (n) {
        n.setAttribute('aria-pressed', n.getAttribute('data-look-note') === key ? 'true' : 'false');
      });
      if (reset) reset.hidden = key === 'figure';
    }

    notes.forEach(function (note) {
      note.addEventListener('click', function () {
        var key = note.getAttribute('data-look-note');
        // Clicking the active piece returns to the full figure
        show(note.getAttribute('aria-pressed') === 'true' ? 'figure' : key);
      });
    });

    if (reset) reset.addEventListener('click', function () { show('figure'); });
  });
})();
